/** @jsx jsx */
import { jsx } from '@emotion/core';
import { beforeElementStyles, roundedBorderStyles } from './styles';

var Before = function Before(_ref) {
  var elemBefore = _ref.elemBefore,
      isRounded = _ref.isRounded,
      styles = _ref.styles;
  return elemBefore ? jsx("span", {
    css: [beforeElementStyles(styles), isRounded ? roundedBorderStyles : undefined]
  }, elemBefore) : null;
};

export default Before;